import { createContext, useContext, useEffect, useState } from "react"

type Theme = 'RondonCap' | 'AcreCap' | 'MegaCap' | 'RoraiCap'

type ThemeProviderProps = {
  children: React.ReactNode
  defaultTheme: Theme
}

type ThemeProviderState = {
  theme: Theme 
  setTheme: (theme: Theme) => void
}

const initialState: ThemeProviderState = {
  theme: "RondonCap",
  setTheme: () => null,
}

const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export function ThemeProvider({
  children,
  defaultTheme = "RondonCap",
  ...props
}: ThemeProviderProps) {
  const [theme, setTheme] = useState<Theme>(
    () => defaultTheme
  )

  useEffect(() => {       
    const root = window.document.documentElement

    root.classList.remove('RondonCap', 'AcreCap', 'MegaCap', 'RoraiCap')   

    root.classList.add(theme)
  }, [theme])

  const value = {
    theme,
    setTheme: (theme: Theme) => {
      setTheme(theme)
    },
  }

  return (
    <ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>
  )
}

export const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  if (context === undefined)
    throw new Error("useTheme must be used within a ThemeProvider")

  return context
}
